"use client";

import { useContext, useEffect } from "react";
import { UserContext } from "@/contexts/user-context";
import { ResourceContext } from "@/contexts/resource-context";
import { scrollToElement } from "@/service/scroll/scroll";

export function Paywall({ children }: { children: any }) {
  const { isCrawler } = useContext(UserContext) as User;
  const { access } = useContext(ResourceContext) as ResourceInfo;

  useEffect(() => {
    if (!access?.granted) return;
    const hash = window.location.hash;
    if (!hash) return;

    setTimeout(() => {
      scrollToElement({ selector: hash, behavior: "instant" });
    }, 100);
  }, [access?.granted]);

  if (isCrawler) {
    return <div className={"paywall"}>{children}</div>;
  }

  if (!access?.granted) {
    return <></>;
  }

  return <>{children}</>;
}
